export enum AuthorizationType {
  Page = 'Page',
  Hidden = 'Hidden',
  Disabled = 'Disabled',
}

export enum RoleTypes {
  Client,
  Locality,
  ServiceStation,
  Storage,
  ProjectPlanning
}

export enum FunctionElementsParentsIds {
  LocalityPortal = 1,
  ServiceStationPortal = 2,
  SystemPortal = 3,
  StoragePortal = 19,
  ProjectPlanningPortal = 21
}
